import React, { useContext } from "react";
import { Box, Center, Group, Image, Text, Divider, Anchor } from "@mantine/core";
import VXLogo from "../assets/vx-logo.svg";
import { DataContext } from "../context/DataContext";
import useLocale from "../hooks/useLocale";

export default function AppFooter() {
  const context = useContext(DataContext) ?? {};
  const { data, settings } = context;

  // Footer text is rendered from the local `useLocale` translations rather
  // than the backend `settings.text.general.*`, which can resolve the wrong
  // script for a language (e.g. `sr-Latn` came back in Cyrillic). `useLocale`
  // maps `sr-Latn` -> `sr-Latn-RS` correctly. The `poweredBy` string already
  // includes "Veratad", so it is rendered as-is (no separate " Veratad").
  const locale = useLocale("footer");

  if (settings?.isFooterShown === false) return null;

  const poweredByText = locale?.poweredBy ?? "Powered by Veratad";
  const privacyPolicyText = locale?.privacyPolicy ?? "Privacy Policy";
  const privacyPolicyHref =
    data?.settings?.journey?.settings?.privacyPolicy ||
    "https://veratad.com/privacy-policy/";

  return (
    <Box
      align="center"
      sx={{
        width: "100%",
        padding: "12px 0 20px 0",
        backgroundColor: "transparent",
      }}
    >
      <Center>
        <Group spacing={10}>
          <Group spacing={5}>
            <Image src={VXLogo} width={20} alt="" />
            <Text fz="xs" c="dimmed">
              {poweredByText}
            </Text>
          </Group>
          <Divider orientation="vertical" />
          <Anchor href={privacyPolicyHref} size="xs" target="_blank">
            {privacyPolicyText}
          </Anchor>
        </Group>
      </Center>
    </Box>
  );
}
